import React from 'react';
import PropTypes from 'prop-types';
import './Select.scss';
import SelectItem from './SelectItem/SelectItem'
import Icon from '../Icon';
//import downIcon from '../../../assets/icons/down.svg';

const select = (props) => {
	const { reference, disabled, value, items, name, clicked, itemClicked, styles, placeholder, showList, small } = props;

	let selected = placeholder;

	const allOptions = items.map((item, i) => {
		if(item.value === value){
			selected = item.description;
		}

		return <SelectItem
			key={i}
			itemClicked={itemClicked}
			inputName={name}
			description={item['description']}
			value={item['value']} />
	});

	return (
		<div style={styles}
			className={['Select',  showList ? 'is-open' : '', disabled ? 'is-disabled' : '', small ? 'Select--sm' : ''].join(' ')}
			ref={reference}>
			<button
				className={'Select-button'}
				onClick={clicked}
				disabled={disabled}
				data-name={name}
			>{ selected === placeholder || selected === 'all' ? <span>{ placeholder }</span> : selected }</button>
			{
				!showList ? <Icon icon={'arrowDown'} /> : <Icon icon={'arrowUp'} />
			}
			<div className={['Select-list', showList ? 'is-visible' : ''].join(' ')}>{ allOptions }</div>
		</div>
	);
};

select.propTypes = {
	styles: PropTypes.object,
	items: PropTypes.arrayOf(PropTypes.object),
	name: PropTypes.string,
	placeholder: PropTypes.string,
	showList: PropTypes.bool,
	value: PropTypes.string,
	clicked: PropTypes.func,
	itemClicked: PropTypes.func,
	reference: PropTypes.func,
	small: PropTypes.bool,
};

export default select;
